import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { selectBootstrapModal } from '../../../store/bootstrap/selector';
import { useLanguage } from '../../../context/language/language';
import { bootstrapModalAction } from '../../../store/bootstrap/actions';
import { goToPath } from '../../../utils/useLocationPath';
import useDeliveryControlFlow from './useDeliveryControlFlow';

const useNotifyModal = () => {
  const modal = useSelector(selectBootstrapModal);
  const deliveryControl = useDeliveryControlFlow();
  const dispatch = useDispatch();
  const word = useLanguage();

  const mode = _.get(modal, 'mode', 'info');
  const isRedirect = _.get(modal, 'isRedirect', false);
  const redirectURL = _.get(modal, 'redirectURL', '');
  const isCloseWithAction = _.get(modal, 'isCloseWithAction', true);
  const isRetryAction = _.get(modal, 'isRetryAction', false);
  const dispatchAction = _.get(modal, 'dispatchAction', null);
  const errorDescription = _.get(modal, 'errorDescription', '');

  let title = word('General.Error.Title');
  let description = word('General.Error.Description').replace(' (%s)', '');
  let labelText = word('General.Error.OK');
  let cancelText = '';

  const pattern = /^\w+.*.*/g;
  const testPattern = (str) => new RegExp(pattern).test(str);

  if (testPattern(modal.title)) {
    title = word(modal.title);

    if (typeof (title) !== 'string' && modal.titleOptions) {
      const { select, replace, with: withKeyword } = modal.titleOptions;
      if (select) {
        title = word(modal.title)[select];
      }
      if (replace && withKeyword) {
        title = title.replace(replace, withKeyword);
      }
    }
  }

  if (_.isString(modal.message) && testPattern(modal.message)) {
    if (modal.replaceMessage) {
      const form = modal.replaceMessage.form || '';
      const to = modal.replaceMessage.to || '';
      description = word(modal.message).replace(form, to);
    } else {
      description = word(modal.message);
    }
  }

  if (testPattern(modal.confirmText)) {
    labelText = word(modal.confirmText);
  }

  if (testPattern(modal.cancelText)) {
    cancelText = word(modal.cancelText);
  }

  const handleRedirectURL = () => {
    if (isRedirect && redirectURL) {
      goToPath(redirectURL);
    }
    if (isRetryAction && dispatchAction) {
      dispatch(dispatchAction);
    }
  };

  const closeModal = () => {
    dispatch(bootstrapModalAction(false));
    if (isCloseWithAction) {
      handleRedirectURL();
    }
  };

  const onConfirm = () => {
    dispatch(bootstrapModalAction(false));
    handleRedirectURL();
  };

  const onNext = () => {
    dispatch(bootstrapModalAction(false));
    deliveryControl.startSFL();
  };

  return {
    mode,
    openModal: modal.info,
    title,
    description,
    buttonText: labelText,
    cancelText,
    type: modal.type,
    closeModal,
    onConfirm,
    onNext,
    errorDescription
  };
};

export default useNotifyModal;
